import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbActiveModal, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { PackageService } from '../../business-services/package.service';
import { SettingService } from '../../business-services/setting.service';
import { AddPackageComponent } from './add-package/add-package.component';
import {PackageListModel} from '../../business-entities/package-list-model';
import { Subscription } from 'rxjs';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { DashboardService } from '../../business-services/dashboard.service';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { BrandType } from '../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../business-services/brand.service';
import { DuplicatePackageModel } from '../../business-entities/add-edit-package-model';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html'
})
export class PackageComponent implements OnInit {
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  popupCloseResult = false;

  userRoleRightsDetails: UserRoleMenu;
  isDealerLoggedIn: boolean;
  currentlagSub: Subscription
  currency: string
  applicationSourceList: any[] = [];
  totalCount: number = 0;
  throttle = 100;
  sourceName:string;
  scrollDistance = 1;
  searchTerm: string = '';
  packagesList: PackageListModel[] = [];
  SyncList: StatusViewModel[] = [];
  StatusList: StatusViewModel[] = [];
  selectedStatus: number;
  subscription : Subscription;
  selectedSync: number;
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
  {
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    moduleId: Enums.ModuleNames.Package,
    logDate: '',
    referenceId: 0
  };
  isDmsSyncPackage : boolean = false;
  dealerList: Array<SelectListItemViewModel>;
  selectedDealerId: string = '';
  isShowDealerDropdown:boolean = false;
  allowDealerBrandLaborRate: boolean = false;
  closeResult: string;
  makeList: BrandType[] = [];
  newPackageNo:string = "";
  newMakeCode:string = "";
  copiedPackage:any;
  constructor(
    private translate: TranslateService,
    private service: PackageService,
    private brandService: BrandService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private userService: UserDataService,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    private applicationSourceService: ApplicationSourceService,
    public settingService: SettingService,
    private dashboardService: DashboardService,
    private dmsService: DMSSyncFailedlogService,
    private secureStorage: SecureStorage,
    public dealerBusinessService: DealerBusinessService,
    private activeModal: NgbActiveModal,
    config: NgbModalConfig,
  ) {

    config.backdrop = 'static';
    config.keyboard = false;
   }

   ngOnDestroy(): void {

    if(this.currentlagSub)
    {
      this.currentlagSub.unsubscribe();
    }
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.service.packageListRequest.sortColumn = column;
    this.service.packageListRequest.sortDirection = direction;
    this.service.packageListRequest.startRecordNumber = 0;
    this.packagesList = [];
    this.getPackageList();
  }
  onRefresh() {
    this.service.packageListRequest.startRecordNumber = 0;
    this.packagesList = []
    this.getPackageList();
  }
  StatusChange(status: any) {
    if (status == undefined) {
      this.service.packageListRequest.statusId = Enums.StatusCode.All;
    } else {
      this.service.packageListRequest.statusId = status;
    }
    this.service.packageListRequest.startRecordNumber = 0;
    this.packagesList = [];
    this.getPackageList();
  }
  onScrollDown(_ev) {
    if(this.totalCount > this.packagesList.length){
      this.service.packageListRequest.startRecordNumber = this.packagesList.length;
      this.getPackageList();
    }

  }


  ngOnInit(): void {
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    if (this.selectedSync != undefined) {
      this.service.packageListRequest.syncId = this.selectedSync;
    }
    if (this.selectedStatus != undefined) {
      this.service.packageListRequest.statusId = this.selectedStatus;
    }
    this.StatusList = this.dashboardService.getStatusList();
    this.SyncList = this.dashboardService.getDmsStatusList();
    this.currency = this.settingService.currencySymbol;
    this.isDealerLoggedIn = this.userService.currentUserValue.roleType === fromEnums.UserRoles.DealerAdmin;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.Package);
    this.service.packageListRequest.cultureCode = this.cookieservice.get('userSelectedLanguage');
    this.service.packageListRequest.startRecordNumber = 0;
    this.getFeatures();
    this.packagesList = [];
    this.GetApplicationSource();
    this.isShowDealerDropdown = localStorage.getItem("Theme") === 'mg';
    if (this.isShowDealerDropdown) {
        this.getUserDealers();
    } else {
      this.getPackageList();
    }
  }
  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealerBusinessService.dealerList = this.dealerList;
      if(this.dealerList.length===1)
      {
        this.onDealerSelected(this.dealerList[0].value);
        this.selectedDealerId = response.userDealersModel[0].dealerId;
      }
    })
  }
  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onDealerSelected(dealerId: string) {
    this.selectedDealerId = dealerId;
    this.service.packageListRequest.dealerId = this.selectedDealerId;
    this.service.packageListRequest.startRecordNumber = 0;
    this.packagesList = [];
    this.getPackageList();
  }


  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if(features == null || features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        features = res;
        if (features?.length > 0) {
          this.isDmsSyncPackage = features.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
          this.allowDealerBrandLaborRate = features.find(x => x.featureCode === fromEnums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
        }
      })
    }else{
      this.isDmsSyncPackage = features.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
      this.allowDealerBrandLaborRate = features.find(x => x.featureCode === fromEnums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
    }
  }
  SyncChange(status: any) {
    if (status == undefined) {
      this.service.packageListRequest.syncId = Enums.DmsSync.All;
    } else {
      this.service.packageListRequest.syncId = status;
    }
    this.service.packageListRequest.startRecordNumber = 0;
    this.packagesList = [];
    this.getPackageList();
  }

  getPackageList() {

    this.spinner.show();
    
    this.service.getPackageList(this.service.packageListRequest).then((response) => {

      this.spinner.hide();
      this.totalCount = 0;
      if( response?.responseObject?.errorCount===1)
      {
        this.spinner.hide();
        let errorMsg = this.translate.instant("lblRecordNotFound");
        this.toastr.error(errorMsg)
      }
      else if(response?.responseObject?.length != 0)
      {

        this.packagesList.push(...this.PackageDataMapper(response.responseObject));
        this.totalCount = this.packagesList.length > 0 ? this.packagesList[0].totalCount : 0;
      }
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  async getPackageVersion(packageId:number,i:number)
  {
    if (this.packagesList[i].expanded) {
      return;
    }
    this.spinner.show();
    let langCode=this.cookieservice.get('userSelectedLanguage');
    this.packagesList[i].packageVersionList=[];
    await this.service.GetPackageVersionByPackageNo(packageId,langCode).then(response => {
      if( response?.responseObject?.errorCount===1)
      {
        if(response.responseObject.result.errorCode===Constant.BadRequest)
        {
          this.spinner.hide();
          let errorMsg = this.translate.instant("lblInvalidParameter");
          this.toastr.error(errorMsg)
        }
        if(response.responseObject.result.errorCode===Constant.InternalError)
        {
          this.spinner.hide();
          let errorMsg = this.translate.instant("lblRecordNotFound");
          this.toastr.error(errorMsg)
        }
      }
      else if(response?.responseObject?.length != 0)
      {
       this.packagesList[i].packageVersionList.push(...this.PackageVersionDataMapper(response.responseObject));
      }

      this.spinner.hide();
    },_error => {
      this.spinner.hide();
    });
  }

  async getPackageBOM(packageId:number,packageVersionId:number,v:number,i:number)
  {
    if (this.packagesList[i].packageVersionList[v].expandedVersion) {
      return;
    }
    this.spinner.show();
    this.packagesList[i].packageVersionList[v].packageBOMList=[];
    await this.service.GetPackageBOMByPackageNo(packageId,packageVersionId,"",this.allowDealerBrandLaborRate).then(response => {
      if(response?.responseObject?.errorCount===1)
      {
        if(response.responseObject.result.errorCode===Constant.BadRequest)
        {
          this.spinner.hide();
          let errorMsg = this.translate.instant("lblInvalidParameter");
          this.toastr.error(errorMsg)
        }
        if(response.responseObject.result.errorCode===Constant.InternalError)
        {
          this.spinner.hide();
          let errorMsg = this.translate.instant("lblRecordNotFound");
          this.toastr.error(errorMsg)
        }
      }
      else if(response?.responseObject?.length != 0)
      {
        this.packagesList[i].packageVersionList[v].packageBOMList.push(...this.PackageBOMDataMapper(response.responseObject));
      }

      this.spinner.hide();
    },_error => {
      this.spinner.hide();
    });
  }


  private PackageDataMapper(packageList: any) {
    let supperArray = [];
    if (packageList && packageList.length > 0) {

      for (let index = 0; index < packageList.length; index++) {
        const element = packageList[index];
        let single = Object();
        single.rowNumber =
        this.service.packageListRequest.startRecordNumber + 1 + index;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.createdDate = element.createdDate ? new Date(element.createdDate + 'Z') : null;
        single.dmsSyncStatus = element.dmsSyncStatus;
        single.id = element.id;
        single.makeCode=element.makeCode;
        single.name = element.name;
        single.packageNumber=element.packageNumber;
        single.sourceType=element.sourceType
        single.sourceTypeId=element.sourceTypeId
        single.totalCount=element.totalCount;
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.expanded = false;
        single.isActive = element.isActive;
        supperArray.push(single);
      }
    }

    return supperArray;
  }

  private PackageVersionDataMapper(packageVersionList: any) {
    let supperArray = [];
    if (packageVersionList && packageVersionList.length > 0) {
      packageVersionList.forEach(element=>{
        let single = Object();
        single.id = element.id;
        single.makeCode=element.makeCode;
        single.name = element.name;
        single.packageId=element.packageId
        single.packageNumber=element.packageNumber;
        single.packageVersionNumber=element.packageVersionNumber;
        single.noOfLine=element.noOfLine;
        single.expandedVersion = false;
        single.salesPriceAmount = element.salesPriceAmount;
        supperArray.push(single);
      })
    }

    return supperArray;
  }


  private PackageBOMDataMapper(packageBOMList: any) {
    let supperArray = [];
    if (packageBOMList && packageBOMList.length > 0) {

      packageBOMList.forEach(element=>{

        let single = Object();
        single.id = element.id;
        single.bomTypeId=element.bomTypeId;
        single.costType = element.costType;
        single.description=element.description
        single.lineNo=element.lineNo;
        single.makeCode=element.makeCode;
        single.no=element.no;
        single.packageId=element.packageId;
        single.packageNumber=element.packageNumber;
        single.packageVersionId=element.packageVersionId;
        single.packageVersionNumber=element.packageVersionNumber;
        single.quantity=element.quantity;
        single.typeName=element.typeName;
        single.unitofMeasureCode=element.unitofMeasureCode;
        single.price=element.unitPrice;
        single.serviceId=element.serviceId;
        single.salesPriceAmount = element.salesPriceAmount;
         supperArray.push(single);
      })
    }

    return supperArray;
  }

  onSearchFilter() {
    this.service.packageListRequest.searchTerm=this.searchTerm;
    this.service.packageListRequest.startRecordNumber = 0;
    this.packagesList = [];
    this.getPackageList();
  }

  editPackagePopUp(packNumber:any,packageId:number,sourceTypeId){
    this.service.packageNumber = packNumber;
    this.service.packageId = packageId;
    this.service.sourceTypeId = sourceTypeId;
    const modalref = this.modalService.open(AddPackageComponent, { size: 'xl', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  async GetAllMake(): Promise<void> {
    this.makeList = await this.brandService.GetBrandDropdownResult();
    this.newMakeCode = this.copiedPackage.makeCode;
  }

  copyPackagePopUp(content,obj){
    this.copiedPackage = obj;
    this.GetAllMake();
    this.modalService.open(content, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
     this.closeResult = `Dismissed ${this.getDismissDeleteReason(reason)}`;
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  createDuplicatePackage(){
    let successMessage = this.translate.instant("lblPackageCopiedSuccessfully");
    let errorMessage = this.translate.instant("lblPleaseProvideMandatoryValue");
    
    if (this.empty(this.newPackageNo) && this.empty(this.newMakeCode)) {
      this.toastr.error(errorMessage);
      return
    }
    let isSyncToDms = this.isDmsSyncPackage;
    //below condition only for BNH
    if(localStorage.getItem("Theme") === 'bnh'){
      isSyncToDms = false;
    }
    let model: DuplicatePackageModel =
    {
      id: this.copiedPackage.id,
      isDmsSyncPackage: isSyncToDms,
      packageNo: this.newPackageNo,
      makeCode: this.newMakeCode,
    }
    this.spinner.show();
    this.service.DuplicatePackage(model).then(res => {

      if (res.responseCode === Constant.SuccessResponseCode) {
        if (res.responseObject.isSuccess) {
          document.getElementById("modelButton").click();
          this.toastr.success(successMessage);
          this.ngOnInit();
        } else {
          if (res.responseObject.retValue == '-8000') {
            this.spinner.hide();
            let errormsg = this.translate.instant("lblPackageNumberAlreadyExists");
            this.toastr.warning(errormsg);
          } else {
            this.spinner.hide();
            let errormsg = this.translate.instant("lblInternalError");
            this.toastr.error(errormsg);
          }
        }
      }
      else if (res.responseCode === Constant.InternalError) {
        this.spinner.hide();
        let errormsg = this.translate.instant("lblInternalError");
        this.toastr.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        this.spinner.hide();
        let errormsg = this.translate.instant("lblAlreadyAddedService");
        this.toastr.warning(errormsg);
      }
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  deletePackageV1(packageId:number){
    this.spinner.show();
    this.service.DeletePackageByNumber(packageId).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        if(response.responseObject === Constant.PackageVersionDeleted)
        {
          let deletedmsg = this.translate.instant("lblPackageDeleted");
          this.toastr.success(deletedmsg);
          this.ngOnInit();
        }
        else if(response.responseObject === Constant.PackageRequireAtleastOneVersion)
        {
          let deletedmsg = this.translate.instant("lblAppointmentAssociatedwiththisPackage");
          this.toastr.error(deletedmsg);
        }
        this.spinner.hide();
      }
    });
  }

  onAdd(){
    this.service.packageNumber = "";
    this.service.packageId = 0;
    const modalref = this.modalService.open(AddPackageComponent, { size: 'xl', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  viewException(Id){
    this.dmsLogRequestModel.referenceId = Id;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => {
            // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissDeleteReason(reason);
          });
        } else {
          this.toastr.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }
  SourceChange(status: any) {
      this.service.packageListRequest.sourceId = status;
      this.service.packageListRequest.startRecordNumber = 0;
      this.packagesList = [];
      this.getPackageList();
  }
  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = data.responseObject;
      this.applicationSourceList = this.applicationSourceList.filter(source => source.sourceId === Enums.SourceId.Planner || source.sourceId === Enums.SourceId.DMS);
    });
  }
  onSyncToDms(packageId){

    let modelHeadermsg = this.translate.instant("lblSyncToDMS");
    let modelBodymsg = this.translate.instant("lblSureToSync");
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.service.ResyncPackage(packageId).then((response) => {
          this.spinner.hide();
          if (response.responseObject.isSuccess) {
            let successMsg = this.translate.instant('lblSyncSuccess')
            this.toastr.success(successMsg);
            this.packagesList = [];
            this.service.packageListRequest.startRecordNumber = 0;
            this.getPackageList();
          } else {
            this.spinner.hide();
            this.toastr.error(errorMsg);
          }
        });
      }
    });
  }

  showDmsLinkButton(sourceTypeId){
      if(localStorage.getItem("Theme") === 'bnh' && this.isDmsSyncPackage && sourceTypeId == 4){
         return true;
      }else if(localStorage.getItem("Theme") === 'mg' && this.isDmsSyncPackage){
         return true;
      }else{
        return false;
      }
  }

  showCopyLinkButton(sourceTypeId){
    if(localStorage.getItem("Theme") === 'bnh' && this.userRoleRightsDetails.canAdd && this.isDmsSyncPackage && sourceTypeId == 4){
       return true;
    }else if((localStorage.getItem("Theme") === 'mg' || localStorage.getItem("Theme") === 'afx') && this.userRoleRightsDetails.canAdd){
       return true;
    }else{
      return false;
    }
  }
  
}
